export default {
    methods: {
      replaceByDefault(e) {
        e.target.src = 'https://previews.123rf.com/images/virtosmedia/virtosmedia2302/virtosmedia230212521/198345820-green-medicine-bottle-with-pills-on-gray-background-3d-illustration.jpg';
      },
    },
  };